import React from "react";

const IframeHeader = ({ settings }) => {
  return (
    <header className=" flex items-center justify-center !min-h-[70px] bg-[#003b8d] !py-[10px] mb-[30px] px-[20px]">
      <h1 className="text-[#fff] text-center text-[24px] ">
        {settings.company_name}
      </h1>
    </header>
  );
};

export default IframeHeader;
